export const images = [
  "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQOibUgIp7BCU1KHLaJ1vDgnBx4l0oOjv_7xg&s",
  "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTqezTR7jJSCmJndX8BwtefDHP7zfbSo8zftw&s",
  "https://literathink.wordpress.com/wp-content/uploads/2016/09/kimi-no-na-wa-trailer-v3-destaque-726x400.jpg",
  "https://wallpapers.com/images/hd/mitsuha-in-the-mirror-your-name-4k-f82rwds6m5jt97zi.jpg",
  "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEgHZ1HCojyaZIf7JUy2KxqccYskVqRSllWCZ8nM5n2QyJYe46Iyf_cbuBlNL7O_rGgTUX4a0IFhXir5cDCqbLQR_d2JFj7cvvCY446DUgRB_id3jxIuSRAbqjwuAlNPxR0mO34rq8yhGE4/s1600/yourname-31m26s.png",
  "https://live.staticflickr.com/65535/51659213761_04b4921fc1_z.jpg",
  "https://i.pinimg.com/736x/6d/70/0b/6d700bbf006878ccb718da5a264be994.jpg",
  "https://i.imgur.com/y2l26Hp.jpeg",
  "https://djuckudynasty.wordpress.com/wp-content/uploads/2017/04/maxresdefault-e1491790647830.jpg",
];

export const frameImg = "https://images.bauerhosting.com/legacy/empire-images/reviews_films/5829f535737b36a41846433e/Your%20Name.jpg?auto=format&w=1440&q=80";

export const bookPassword = process.env.REACT_APP_BookPassword;
export const loginPassword = process.env.REACT_APP_LoginPass;
export const bookOuterCover = "https://i.pinimg.com/564x/4f/59/5f/4f595f1a2ea869ccd4fb9f58436af433.jpg";
export const bookInsideCover = "https://wallpapers.com/images/featured/kimi-no-na-wa-b5qwq6u6ea6qfd94.jpg";
export const preciousMomentVideo = "Kimi No Nawa (286).mp4";
